import styled from '@emotion/styled';

export const StyledCardWrapper = styled.div`
    background-color: ${(props) => props.theme.shades.white};
    border: 1px solid ${(props) => props.theme.shades.lightMidGrey};
    color: ${(props) => props.theme.shades.blackGrey};
    width: 100%; /* IE reasons */
    display: flex;
    flex-direction: ${(props: { flexDirection: string }) => props.flexDirection};
`;
